<div class="dialog-content-wrapper contract-creator-missing-data-dialog">
    <mat-toolbar color="accent" class="m-0" fxLayout="row" fxLayoutAlign="space-between center">
        <div class="title dialog-title">
            {{ 'workflows.screens.contractCreator.preflightTitle' | translate }}
        </div>
        <button mat-icon-button type="button" (click)="onCancel()"
                [attr.aria-label]="'common.closeDialogAria' | translate">
            <mat-icon>close</mat-icon>
        </button>
    </mat-toolbar>

    <div mat-dialog-content>
        <p class="contract-creator-missing-data-dialog__lead">
            {{ 'workflows.screens.contractCreator.preflightLead' | translate }}
        </p>

        <u2b-message type="warning">
            <header>{{ 'workflows.screens.contractCreator.missingDataHeader' | translate }}</header>
            <p>{{ 'workflows.screens.contractCreator.missingDataIntro' | translate }}</p>

            <ng-container *ngIf="data.missingFields.tenant?.length">
                <p><strong>{{ 'workflows.screens.contractCreator.missingTenantTitle' | translate }}</strong></p>
                <ul>
                    <li *ngFor="let item of data.missingFields.tenant">{{ item }}</li>
                </ul>
            </ng-container>

            <ng-container *ngIf="data.isPerson && data.missingFields.person?.length">
                <p><strong>{{ 'workflows.screens.contractCreator.missingPersonTitle' | translate }}</strong></p>
                <ul>
                    <li *ngFor="let item of data.missingFields.person">{{ item }}</li>
                </ul>
            </ng-container>

            <ng-container *ngIf="!data.isPerson && data.missingFields.company?.length">
                <p><strong>{{ 'workflows.screens.contractCreator.missingCompanyTitle' | translate }}</strong></p>
                <ul>
                    <li *ngFor="let item of data.missingFields.company">{{ item }}</li>
                </ul>
            </ng-container>

            <ng-container *ngIf="data.missingFields.boat?.length">
                <p><strong>{{ 'workflows.screens.contractCreator.missingBoatTitle' | translate }}</strong></p>
                <ul>
                    <li *ngFor="let item of data.missingFields.boat">{{ item }}</li>
                </ul>
            </ng-container>

            <ng-container *ngIf="data.missingFields.berth?.length">
                <p><strong>{{ 'workflows.screens.contractCreator.missingBerthTitle' | translate }}</strong></p>
                <ul>
                    <li *ngFor="let item of data.missingFields.berth">{{ item }}</li>
                </ul>
            </ng-container>
        </u2b-message>
    </div>

    <div mat-dialog-actions fxLayout="row" fxLayoutAlign="space-between center">
        <button mat-flat-button type="button" (click)="onCancel()">
            {{ 'common.cancel' | translate }}
        </button>
        <button mat-flat-button color="accent" type="button" (click)="onContinue()">
            <mat-icon>save</mat-icon>
            <span>{{ 'workflows.screens.contractCreator.preflightContinue' | translate }}</span>
        </button>
    </div>
</div>
